import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import marked from "marked"; //to make font bold and headings
import {Link} from 'react-router-dom';
import LandscapeDesignFlashImages from "./LandscapeDesignFlashImages";
import LandscapeForm from "../Components/LandscapeForm";

class LandscapeDesign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      landscapedetailspage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "landscapeDesignNew",
    }).then((entries) => {
      this.setState({ landscapedetailspage: entries.items });
    });
  }

  //to make font bold and headings
  getParsedMarkdown(landscapeDesignDescription) {
    return {
      __html: marked(landscapeDesignDescription, { sanitize: false }),
    };
  }
  //to make font bold and headings - end

  render() {
    return (
      <>
      <div className="container-fluid">
        {this.state.landscapedetailspage.length === 0 ? (
          <div align="center">
            <img src={BlackLoading} alt="Loading..." />
          </div>
        ) : (
          <div className="row">
            {this.state.landscapedetailspage.map((item, index) => {
              return (
                <div key={index} className="col-lg-12">
                  <div className="text-left pt-2">
                    <h1 className="text-uppercase">{item.fields.landscapeDesignTitle}</h1>
                    <h2 className="lead">{item.fields.landscapeDesignShortDetails}</h2>
                  </div>

                  <div className="pt-2">
                    <div className="row">
                    <div className="col-lg-4">
                    <Link to="/landscape-design-gallery"><img
                          className="img-fluid"
                          src={item.fields.landscapeDesignImg.fields.file.url}
                          alt="landscape design"
                        /></Link>                    
                      </div>
                        
                      <div className="col-lg-8">
                        {/* <p>{item.fields.aboutDescription}</p> */}
                        <div dangerouslySetInnerHTML = {this.getParsedMarkdown(
                            item.fields.landscapeDesignDescription
                        )}></div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div><LandscapeForm/></div>

          <div className="pt-4">
            <Link to="/landscape-design-gallery"><LandscapeDesignFlashImages/></Link>  
          </div>
      </div>
      </>
    );
  }
}

export default LandscapeDesign;
